export const handleStretchToFullWidth = ({
  value,
  onChange,
  id,
  enableColActions,
  addColButtonWidth,
  fullWidthCompWrapper,
}) => {
  const { data, colWidthConfig } = value;

  const totalAvailableWidth =
    fullWidthCompWrapper.current?.getBoundingClientRect().width -
    (enableColActions ? addColButtonWidth : 0);
  const noOfCols = data[0].cellData.length;
  const widthPerCol = totalAvailableWidth / noOfCols + "px";

  const newColWidthConfig = Object.keys(colWidthConfig)
    .map((k) => ({
      colId: k,
      width: widthPerCol,
    }))
    .reduce((a, b) => ({ ...a, [b.colId]: b.width }), {});

  onChange && onChange(id, { data, colWidthConfig: newColWidthConfig });
};
